<template>
    <div class="bg-white rounded shadow  container-box">
        <div class="row">
            <div class="col-md-12 mb-2">
              <div class="mdc-tab-bar-wrapp">
  
                <nav class="mdc-tab-bar mdc-tab-bar-upgraded" v-if="loaded">
    
                  <router-link class="mdc-tab mdc-ripple-upgraded" :to="{name: 'protocol-item'}"
                               :class="{'mdc-tab--active': 'protocol-item' === route.name}">
                    <span>{{'protocol.header' | trans}}</span></router-link>
    
                  <router-link class="mdc-tab mdc-ripple-upgraded"
                               v-if="activeProtocolList.length != 1 &&
                                    !isPecsWithItems() &&
                                    !isPecs() &&
                                    !isPecsWithoutDiscrimination() &&
                                    !isCompleted() &&
                                    !isMensurationForbidden &&
                                    !isClient &&
                                    !isOnIndividualization()"
                               :to="{name: 'stage-list'}"
                               :class="{'mdc-tab--active':
                                    'current-stage' === route.name ||
                                    'choose-stage' === route.name ||
                                    'mastering-stage' === route.name ||
                                    'rotation-stage' === route.name ||
                                    'fluency-stage' === route.name ||
                                    'maintain-stage' === route.name ||
                                    'stage-list' === route.name ||
                                    'mand-stage-current' === route.name ||
                                    'choose-usd' === route.name ||
                                    'pecs-with-discrimination-stage' === route.name ||
                                    'shaping-stage-current' === route.name ||
                                    'chain-stage-current' === route.name ||
                                    'mastering-stage-usd' === route.name ||
                                    'maintain-stage-usd' === route.name}">
                    <span>{{'protocol.exercises' | trans}}</span></router-link>
  
  
                  <router-link class="mdc-tab mdc-ripple-upgraded"
                               v-if="activeProtocolList.length === 1 &&
                               !isPecsWithItems() &&
                               !isPecsWithDiscrimination() &&
                               !isPecs() &&
                               !isPecsWithoutDiscrimination() &&
                               !isUSD() &&
                               !isDtt()  &&
                               !isSimple() &&
                               !isCompleted() &&
                               !isMensurationForbidden &&
                               !isClient &&
                               !isOnIndividualization()"
                               :to="{ name: isChain() ? 'chain-stage-current' : isShaping() ? 'shaping-stage-current' : 'mand-stage-current',
                                params: {clientId: clientId, protocolId: protocolId, stageId:activeProtocolList[0].id}}"
                               :class="{'mdc-tab--active':
                                    'mand-stage-current' === route.name ||
                                    'shaping-stage-current' === route.name ||
                                    'chain-stage-current' === route.name ||
                                    'shaping-stage-current' === route.name ||
                                    'chain-stage-current' === route.name ||
                                    'pecs-with-discrimination-stage' === route.name ||
                                    'mand-stage-current' === route.name}">
                    <span>{{'protocol.exercises' | trans}}</span>
                  </router-link>
                  <router-link class="mdc-tab mdc-ripple-upgraded"
                               v-if="activeProtocolList.length === 1 &&
                               isUSD() &&
                               !isCompleted() &&
                               !isMensurationForbidden &&
                               !isClient &&
                               !isOnIndividualization()"
                               :to="{ name: 'choose-usd',
                      params: {clientId: clientId, protocolId: protocolId, stageId:activeProtocolList[0].id}}"
                               :class="{'mdc-tab--active':
                                    'choose-usd' === route.name ||
                                    'mastering-stage-usd' === route.name ||
                                    'maintain-stage-usd' === route.name}">
                    <span>{{'protocol.exercises' | trans}}</span>
                  </router-link>
                  <router-link class="mdc-tab mdc-ripple-upgraded"
                               v-if="activeProtocolList.length === 1 &&
                               isDtt() &&
                               !isCompleted() &&
                               !isMensurationForbidden &&
                               !isClient &&
                               !isOnIndividualization()"
                               :to="{ name: 'choose-stage',
                      params: {clientId: clientId, protocolId: protocolId, stageId:activeProtocolList[0].id}}"
                               :class="{'mdc-tab--active':
                                    'mastering-stage' === route.name ||
                                    'rotation-stage' === route.name ||
                                    'fluency-stage' === route.name ||
                                    'maintain-stage' === route.name ||
                                    'choose-stage' === route.name}">
                    <span>{{'protocol.exercises' | trans}}</span>
                  </router-link>

                  <router-link class="mdc-tab mdc-ripple-upgraded" v-if="isPecs() && !isCompleted() && !isMensurationForbidden && !isClient && !isOnIndividualization()"
                               :to="{ name: 'pecs-stage',
                      params: {clientId: clientId, protocolId: protocolId, stageId:protocol.protocol.stages[0].id}}"
                               :class="{'mdc-tab--active':
                                    'pecs-stage' === route.name}">
                    <span>{{'protocol.exercises' | trans}}</span>
                  </router-link>

                  <router-link class="mdc-tab mdc-ripple-upgraded" v-if="isPecsWithoutDiscrimination() && !isCompleted() && !isMensurationForbidden && !isClient && !isOnIndividualization()"
                               :to="{ name: 'pecs-stage-without-discrimination',
                      params: {clientId: clientId, protocolId: protocolId, stageId:protocol.protocol.stages[0].id}}"
                               :class="{'mdc-tab--active':
                                    'pecs-stage-without-discrimination' === route.name}">
                    <span>{{'protocol.exercises' | trans}}</span>
                  </router-link>

                  <router-link class="mdc-tab mdc-ripple-upgraded" v-if="activeProtocolList.length === 1 && isPecsWithDiscrimination() && !isCompleted() && !isMensurationForbidden && !isClient && !isOnIndividualization()"
                               :to="{ name: 'pecs-with-discrimination-stage',
                      params: {clientId: clientId, protocolId: protocolId, stageId:protocol.protocol.stages[0].id}}"
                               :class="{'mdc-tab--active':
                                    'pecs-with-discrimination-stage' === route.name}">
                    <span>{{'protocol.exercises' | trans}}</span>
                  </router-link>

                  <router-link class="mdc-tab mdc-ripple-upgraded"
                               v-if="isPecsWithItems() &&
                               !isCompleted() &&
                               !isMensurationForbidden &&
                               !isClient &&
                               !isOnIndividualization()"
                               :to="{ name: 'pecs-with-items-stage',
                               params: {clientId: clientId, protocolId: protocolId, stageId:protocol.protocol.stages[0].id}}"
                               :class="{'mdc-tab--active':
                               'pecs-with-items-stage' === route.name}">
                    <span>{{'protocol.exercises' | trans}}</span>
                  </router-link>
  
                  <router-link class="mdc-tab mdc-ripple-upgraded"
                               v-if="activeProtocolList.length === 1 &&
                               isSimple() &&
                               !isCompleted() &&
                               !isMensurationForbidden &&
                               !isClient &&
                               !isOnIndividualization()"
                               :to="{ name: 'current-stage',
                     params: {clientId: clientId, protocolId: protocolId, stageId:activeProtocolList[0].id}}"
                               :class="{'mdc-tab--active':
                                    'current-stage' === route.name}">
                    <span>{{'protocol.exercises' | trans}}</span>
                  </router-link>
                  
  
                  <router-link v-if="!isOnIndividualization()" class="mdc-tab mdc-ripple-upgraded" :to="{name: 'results'}"
                               :class="{'mdc-tab--active': 'results' === route.name}">
                    <span>{{'protocol.results' | trans}}</span></router-link>
                </nav>
                
                
                
              </div>
              <hr>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
    
                <button type="button"
                        class="btn btn-light back btn-sm"
                        v-if="!isClient"
                        @click.prevent="backToPreviousPage()">
                    <i class="material-icons mdc-button__icon">arrow_back</i>
                    <span>{{'buttons.back_to_client' | trans}}</span> <span v-if="loaded && (clientId || assignedProtocolId)">{{client.code}} ({{client.hash}})</span>
                </button>

                <loader v-if="!loaded"></loader>
                <router-view :protocolData="protocol" :clientData="client" :teachingMethod="teachingMethodId"  :client="client" :clientId="clientId || assignedProtocolId" :key="route.key" v-if="loaded && protocol"/>
            </div>
        </div>
        <dashboard-menu v-if="assignedProtocolId && client"
                        :clientId="assignedProtocolId"
                        :clientData="client"
                        :hideDroModal=hideDroModal
                        :checkHasAccess=checkHasAccess
                        :checkedHasAccess=hasAccess />
    </div>
</template>

<script>
  import axios from 'axios';
  import {mapGetters, mapState, mapActions} from 'vuex';
  import DashboardMenu from '../../dashboardParent/components/DashboardMenu';
  import {PROTOCOL_STATUSES} from '../../protocols/constants.js';
  import Loader from '../../loader/components/Loader';
  import filter from 'lodash/filter';

  export default {
    components: {DashboardMenu, Loader},
    name: 'AvailableProtocolLayout',
    props: {
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'teachingMethod': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        apiUrl: '/protocols/assigned/',
        apiClientUrl: '/users/clients/',
        client: null,
        isAssignedProtocolFinished: false,
        assignedProtocolId: null,
        hideDroModal: false,
        statusId: null,
        teachingMethodId: this.teachingMethod,
        loaded: false,
        protocol: null,
        hasAccess: false,
        checkHasAccess: true,
        unavailableRoutes: {
          simple: ['protocol-item', 'stage-list', 'current-stage', 'results'],
          chain: ['protocol-item', 'chain-stage-current', 'stage-list', 'results'],
          usd: ['protocol-item', 'choose-usd', 'stage-list', 'mastering-stage-usd', 'maintain-stage-usd', 'results'],
          mand: ['protocol-item', 'stage-list', 'mand-stage-current', 'results'],
          dtt: ['protocol-item', 'stage-list', 'choose-stage', 'mastering-stage', 'rotation-stage', 'fluency-stage', 'maintain-stage', 'results'],
          nonDtt: ['protocol-item', 'stage-list', 'current-stage', 'results'],
          shaping: ['protocol-item', 'stage-list', 'shaping-stage-current', 'results'],
          pecs: ['protocol-item', 'stage-list', 'pecs-stage', 'results'],
          pecsDiscrimination: ['protocol-item', 'stage-list', 'pecs-stage-without-discrimination', 'results'],
          pecsWithDiscrimination: ['protocol-item', 'stage-list', 'pecs-with-discrimination-stage', 'results'],
          pecsWithItems: ['protocol-item', 'pecs-with-items-stage', 'results'],
        }
      };
    },
    created() {
      this.detectProtocol();
    },
    computed: {
      ...mapGetters('auth', [
        'getUserInfo',
        'isBCBA',
        'isTherapist',
        'isCurator',
        'isClient',
        'isMensurationForbidden',
      ]),
      ...mapState([
        'route',
      ]),

      ...mapState('protocol', [
        'protocolVuexData',
      ]),


      activeProtocolList(){
        let activeList = filter(this.protocol.protocol.stages, stage => !stage.isClosed)

        return activeList;
      },
      
    },
    methods: {

      ...mapActions('protocol', [
        'setProtocol',
        'setProtocolVersion',
      ]),


      isCompleted: function () {
        return this.statusId === PROTOCOL_STATUSES.COMPLETED;
      },
      isOnIndividualization: function () {
        return this.statusId === PROTOCOL_STATUSES.INDIVIDUALIZATION;
      },
      isDtt: function () {
        return this.teachingMethodId === 1;
      },
      isSimple: function () {
        return this.teachingMethodId === 2;
      },
      isMand: function () {
        return this.teachingMethodId === 3;
      },
      isUSD: function () {
        return this.teachingMethodId === 4;
      },
      isChain: function () {
        return this.teachingMethodId === 5;
      },
      isShaping: function () {
        return this.teachingMethodId === 6;
      },
      isPecs: function () {
        return this.teachingMethodId === 7;
      },
      isPecsWithoutDiscrimination: function () {
        return this.teachingMethodId === 8;
      },
      isPecsWithDiscrimination: function () {
        return this.teachingMethodId === 9;
      },
      isPecsWithItems: function () {
        return this.teachingMethodId === 10;
      },
      isRouteMatchToTeachingMethod: function() {
        let unavailableRoutes = this.unavailableRoutes.nonDtt;

        if (this.isDtt()){
          unavailableRoutes = this.unavailableRoutes.dtt
        }

        if (this.isMand()){
          unavailableRoutes = this.unavailableRoutes.mand
        }

        if (this.isUSD()){
          unavailableRoutes = this.unavailableRoutes.usd
        }

        if (this.isChain()){
          unavailableRoutes = this.unavailableRoutes.chain
        }

        if (this.isShaping()){
          unavailableRoutes = this.unavailableRoutes.shaping
        }
        if (this.isPecs()){
          unavailableRoutes = this.unavailableRoutes.pecs
        }

        if (this.isPecsWithoutDiscrimination()){
          unavailableRoutes = this.unavailableRoutes.pecsDiscrimination
        }

        if (this.isPecsWithDiscrimination()){
          unavailableRoutes = this.unavailableRoutes.pecsWithDiscrimination
        }

        if (this.isPecsWithItems()){
          unavailableRoutes = this.unavailableRoutes.pecsWithItems
        }

        return !!unavailableRoutes.includes(this.route.name);
      },
      backToProtocolPage: function() {
        this.$router.push({name: 'protocol-item', params: {clientId: this.clientId || this.assignedProtocolId }});
      },
      detectProtocol: async function() {
        if (!this.teachingMethodId) {
          let response = await axios.get(this.apiUrl + this.protocolId + '/teaching-method' );
          this.teachingMethodId = response.data.data.id;
        }
        if (this.isDtt()){
          this.apiUrl = '/protocols/assigned/dtt/'
        }

        if (this.isMand()){
          this.apiUrl = '/protocols/assigned/mand/'
        }

        if (this.isUSD()){
          this.apiUrl = '/protocols/assigned/vcd/'
        }

        if (this.isChain()){
          this.apiUrl = '/protocols/assigned/chain/'
        }

        if (this.isShaping()){
          this.apiUrl = '/protocols/assigned/shaping/'
        }

        if (this.isSimple()){
          this.apiUrl = '/protocols/assigned/simple/'
        }

        if (this.isPecs()){
          this.apiUrl = '/protocols/assigned/pecs-sentence-structure/'
        }

        if (this.isPecsWithoutDiscrimination()){
          this.apiUrl = '/protocols/assigned/pecs-without-discrimination/'
        }

        if (this.isPecsWithDiscrimination()){
          this.apiUrl = '/protocols/assigned/pecs-with-discrimination/'
        }

        if (this.isPecsWithItems()){
          this.apiUrl = '/protocols/assigned/pecs-features-with-items/'
        }

        if(!this.isRouteMatchToTeachingMethod()) {
          this.backToProtocolPage();
        }
        this.fetchProtocol()
      },
      fetchProtocol: async function() {
        let response;
        response = await axios.get(this.apiUrl + this.protocolId + '/info');

        this.protocol = response.data.data;
        this.setProtocol(response.data.data);
        
        this.assignedProtocolId = this.protocol.assigneeId;
        this.statusId = this.protocol.status.id;
        if(this.protocol){
          this.getClient(this.clientId || this.assignedProtocolId);
        }
      },
      getClient: async function(clientId) {
        try {
          let response = await axios.get(this.apiClientUrl + clientId);
          this.client = response.data.data;
          this.loaded = true;
        } catch (error) {
          console.info(error)
          this.loaded = true;
        }
      },
      backToPreviousPage() {
        if (this.clientId || this.assignedProtocolId) {
          this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
        }
        else {
          this.$router.push({name: 'protocols'});
        }
      },
    },
    watch: {
      protocolVuexData(value){
        if(!value){
          this.detectProtocol();
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/AvailableProtocolLayout.vue